import {
  VehicleChargeGrade,
  VehicleFuelGrade,
  VehicleFuelType,
} from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";
import { isNull } from "lodash";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import formatPrice from "@/core/helpers/formatPrice";
import { GasStationState } from "@/domains/gasStation/slice.ts";

type Props = {
  className?: string;
  fuelTypes: GasStationState["station"]["fuelTypes"];
  selectedFuelType: VehicleFuelType;
  selectedFuelAmount: number;
  selectedFuelGrade: VehicleFuelGrade | VehicleChargeGrade | null;
};
export default function GasStationPurchaseDetails({
  className,
  fuelTypes,
  selectedFuelType,
  selectedFuelAmount,
  selectedFuelGrade,
}: Props) {
  const { t } = useTranslation("gasStation");

  const price = useMemo(() => {
    if (!selectedFuelType) return null;

    const selectedItem = fuelTypes[selectedFuelType];
    if ("price" in selectedItem) {
      return selectedItem.price;
    }
    if (selectedItem?.[selectedFuelGrade]?.price) {
      return selectedItem?.[selectedFuelGrade]?.price;
    }
    return null;
  }, [fuelTypes, selectedFuelGrade, selectedFuelType]);

  const total = price ? price * selectedFuelAmount : null;

  return (
    <div className={cn("flex items-end justify-between", className)}>
      <div className="flex flex-col items-start">
        <div className="text-18 font-bold text-accent">
          {isNull(total) ? "-" : `${formatPrice(total)} ₽`}
        </div>
        <div className="text-15 font-medium text-white">{t("gasStation.totalToBePaid")}</div>
      </div>
      <div className="flex flex-col items-end">
        <div className="text-18 font-bold text-white">
          {price ? `${formatPrice(price)} ₽` : "-"}
        </div>
        <div className="text-15 font-medium text-white/60">{t("gasStation.pricePerUnit")}</div>
      </div>
    </div>
  );
}
